import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type Organisation from "./Organisation";
import type OutreachCommunication from "./OutreachCommunication";
import type User from "./User";

@Model()
class OutreachCommunicationUser extends ApplicationRecord {
  static jsonapiType = "outreach_communication_users";

  @BelongsTo() organisation: Organisation;

  @Attr() organisationId: number;

  @BelongsTo() outreachCommunication: OutreachCommunication;

  @Attr() outreachCommunicationId: number;

  @BelongsTo() user: User;

  @Attr() userId: number;
}

export default OutreachCommunicationUser;
